import type { JSONContent } from '@tiptap/core'

import { tagNodeName } from '@/services/forms/tmTiptap/const'

export const findTags = (docContent: JSONContent) => {
  const { type, content } = docContent
  if (type === tagNodeName) {
    return [docContent]
  }
  if (content) {
    return content.reduce<JSONContent[]>((acc, doc) => {
      acc.push(...findTags(doc))
      return acc
    }, [])
  }
  return []
}
